import React from 'react';
import './NotFound.scss';

const NotFound: React.FC = () => {
  return (
    <div className="not-found">
      <div className="not-found__content">
        <p className="not-found__code">404</p>
        <h1 className="not-found__title">Page not found</h1>
      </div>
    </div>
  );
};

export default NotFound;
